<template>
  <MzSelect
    searchable
    class="mb-3 mt-2 select-member"
    :options="members"
    :value.sync="member_id"
    @update:value="(v) => updateMember(v)"
  />
</template>

<script>
import {ActiveUser} from "../services/user";
import {MemberService} from "../services/members";

export default {
  name: "MemberSelect",
  props: {
    selectedMemberId: {
      type: [String, Number],
      default: undefined,
    },
    addEmpty: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      members: [],
      userData: {},
      member_id: ''
    }
  },
  async mounted() {
    await this.getMembers();
  },
  methods: {
    updateMember(v) {
      this.member_id = v;
      if (this.member_id !== this.selectedMemberId)
        this.$emit("updateMemberId", v);
    },
    async getMembers() {
      this.userData = ActiveUser.get();
      if (!ActiveUser.isSuperUser()) {
        let members = []
        if (this.$route.params.campaignId)
          members = await MemberService.getCampaignMembers(this.$route.params.campaignId);
        else
          members = await MemberService.getMembers();

        if (this.userData.role === 'User') {
          members = members.filter(
            (member) => member.email === this.userData.email
          );
        }

        this.members = members
            .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
            .map((member) => ({
              value: member.id_member,
              label: member.name,
            }));

        if (this.addEmpty) {
          const empty_member = {value: null, label: 'Not selected'}
          this.members.unshift(empty_member)
        }

        if (this.selectedMemberId) {
          this.member_id = this.selectedMemberId
        } else if (this.members.length) {
          this.member_id = this.members[0].value
          this.$emit("updateMemberId", this.member_id);
        }
      }
    }
  }
}
</script>

<style>
.select-member {
  width: 300px;
  font-size: small;
}

.mz-option {
  font-weight: normal !important;
}
</style>
